/**
 * @generated SignedSource<<2989c7747a4b2282a9646d7ea8de2cb4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type ExpectedSupplierAmountOrigin = "CONTINUED_ESTIMATE" | "ESTIMATE" | "INVOICED_USAGE" | "%future added value";
export type ExpenseCategory = "CONSULTING_AND_ADMINISTRATION" | "HARDWARE_AND_EQUIPMENT" | "INFRASTRUCTURE" | "INSURANCE" | "MEMBERSHIPS_AND_DONATIONS" | "OTHER" | "SERVICES_AND_LICENSES" | "TRAVEL" | "VEHICLES" | "%future added value";
export type ForecastBwaField = "DEPRECIATION" | "HOSTING_AND_LICENCES" | "INCOME_TAXES" | "OTHER_COSTS" | "OTHER_OPERATING_INCOME" | "PERSONNEL_COSTS" | "REVENUE" | "%future added value";
export type ForecastPartKind = "BANK_BOOKINGS" | "BWA" | "EXPENSE_SUPPLIER" | "INVOICES" | "OPEN_INVOICE" | "PLANNED_ITEM" | "SUBSCRIPTION" | "SUPPLIER" | "VAT_PAYMENT" | "%future added value";
export type ForecastVatComponentKind = "EXPECTED_SUBSCRIPTION" | "EXPECTED_SUPPLIER" | "INCOMING_INVOICES" | "OUTGOING_INVOICES" | "PLANNED_ITEM" | "%future added value";
export type SupplierAmountEstimateSource = "HETZNER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AnalysisForecastPartsPanel_part$data = {
  readonly bwaField: ForecastBwaField | null | undefined;
  readonly count: number | null | undefined;
  readonly date: any | null | undefined;
  readonly expenseCategory: ExpenseCategory | null | undefined;
  readonly grossAmount: number;
  readonly isPostponedToNextMonth: boolean;
  readonly kind: ForecastPartKind;
  readonly label: string | null | undefined;
  readonly netAmount: number;
  readonly sourceIdentifier: string | null | undefined;
  readonly supplierAmountEstimate: {
    readonly estimatedAt: any | null | undefined;
    readonly origin: ExpectedSupplierAmountOrigin;
    readonly source: SupplierAmountEstimateSource;
  } | null | undefined;
  readonly vatAmount: number;
  readonly vatPayable: {
    readonly amount: number;
    readonly components: ReadonlyArray<{
      readonly count: number | null | undefined;
      readonly kind: ForecastVatComponentKind;
      readonly label: string | null | undefined;
      readonly sourceIdentifier: string | null | undefined;
      readonly vatAmount: number;
    }>;
    readonly month: string;
    readonly paymentDate: any;
  } | null | undefined;
  readonly " $fragmentType": "AnalysisForecastPartsPanel_part";
};
export type AnalysisForecastPartsPanel_part$key = {
  readonly " $data"?: AnalysisForecastPartsPanel_part$data;
  readonly " $fragmentSpreads": FragmentRefs<"AnalysisForecastPartsPanel_part">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "AnalysisForecastPartsPanel_part"
};

(node as any).hash = "5c3a710ed87e935df42ecb23998d0d00";

export default node;
